import STTypo, { STTypoModels } from 'core/shared/typo';
import type { RegionalOverviewLevel } from '@features/regional-overview/regional-overview.models';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface RegionalOverviewMycotoxinFieldsClusteredContainerProps {
  fieldRiskLevel?: RegionalOverviewLevel;
}

const RegionalOverviewMycotoxinFieldLevelType: React.FC<RegionalOverviewMycotoxinFieldsClusteredContainerProps> = ({ fieldRiskLevel }) => {
  const [t] = useTranslation();

  return (
    <div
      data-testid='regional-overview-mycotoxin-field-level-type-container'
      style={{
        width: 'fit-content',
        height: 20,
        backgroundColor: fieldRiskLevel?.legend_color,
        borderRadius: 4,
        paddingRight: 9,
        paddingLeft: 9
      }}>
      <STTypo type={STTypoModels.TypeOptions.P1} color={fieldRiskLevel?.text_color} fontWeight={500}>
        {t(`pages.regional_overview.regional_mycotoxin.fields_clustered.level_type.${fieldRiskLevel?.type}`)}
      </STTypo>
    </div>
  );
};

export default RegionalOverviewMycotoxinFieldLevelType;
